import { DEFAULT_LANGUAGE, type Language } from "./language";
import { MESSAGES, type Messages } from "./messages";

/**
 * The screen's words in the chosen language (L10N1). Every reader asks `phrases()` when it
 * writes, never at import, so a switch shows on the next frame; the page, not this module,
 * decides the language at boot (`src/front/language.ts`), and tests read English.
 */
export {
  DEFAULT_LANGUAGE,
  isLanguage,
  LANGUAGE_LABELS,
  LANGUAGES,
  type Language,
  languageOf,
  type Translations,
} from "./language";
export type { Messages } from "./messages";
export { counted, type PluralForms, plural } from "./plural";
export { NAME_WORDS, type NameWords } from "./text/names";

let current: Language = DEFAULT_LANGUAGE;
const listeners = new Set<(language: Language) => void>();

export function language(): Language {
  return current;
}

export function phrases(): Messages {
  return MESSAGES[current];
}

/** Speaks `next` from now on and tells every listener; the same language again tells nobody. */
export function setLanguage(next: Language): void {
  if (next === current) {
    return;
  }
  current = next;
  for (const listener of listeners) {
    listener(next);
  }
}

/** Hears every switch of language until the returned function is called. */
export function onLanguageChange(listener: (language: Language) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
